var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcMoneyWithdraw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 42,
    viewBox: "0 0 43 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.07,
    cx: 21.625,
    cy: 21,
    r: 21,
    fill: "#5AC8FA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.2988 15.055L24.2718 12.8787L23.8496 12.0252C23.5734 11.4705 22.8996 11.2414 22.3448 11.5176L15.2073 15.055H16.2988Z",
    fill: "#5AC8FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7468 12.9419C26.648 12.9419 26.5492 12.9554 26.4504 12.9823L24.5773 13.4944L18.8569 15.0553H25.3499H28.1797L27.8294 13.7706C27.6946 13.2698 27.2409 12.9419 26.7468 12.9419Z",
    fill: "#5AC8FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3499 15.8408H29.0938H28.7457H28.3976H25.7407H15.9776H14.6974H13.6194H13.4195H12.7502C12.3954 15.8408 12.0787 16.0048 11.8721 16.2631C11.7777 16.3821 11.7059 16.5191 11.6654 16.6696C11.6407 16.7639 11.625 16.8627 11.625 16.9638V17.0985V18.3787V29.4759C11.625 30.0958 12.1281 30.5988 12.748 30.5988H29.3476C29.9675 30.5988 30.4706 30.0958 30.4706 29.4759V26.3428H23.8069C22.7536 26.3428 21.8979 25.4871 21.8979 24.4337V23.4051V23.057V22.7089V21.9363C21.8979 21.4197 22.1045 20.9503 22.4391 20.6067C22.7356 20.3012 23.1331 20.0946 23.5778 20.043C23.652 20.034 23.7283 20.0295 23.8047 20.0295H29.5363H29.8844H30.2325H30.4706V16.9638C30.4728 16.3439 29.9698 15.8408 29.3499 15.8408Z",
    fill: "#5AC8FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2589 21.1028C31.1466 20.9995 31.0141 20.9209 30.8658 20.8692C30.7513 20.8311 30.63 20.8086 30.502 20.8086H30.4728H30.4503H30.1022H28.8467H23.8069C23.187 20.8086 22.6839 21.3117 22.6839 21.9316V22.4908V22.8389V23.187V24.4313C22.6839 25.0511 23.187 25.5542 23.8069 25.5542H30.4728H30.502C30.63 25.5542 30.7513 25.5318 30.8658 25.4936C31.0141 25.4442 31.1466 25.3633 31.2589 25.26C31.4835 25.0556 31.625 24.7592 31.625 24.4313V21.9316C31.625 21.6036 31.4835 21.3071 31.2589 21.1028ZM26.1516 23.4049C26.1516 23.7148 25.9001 23.9663 25.5901 23.9663H25.2173C24.9074 23.9663 24.6558 23.7148 24.6558 23.4049V23.032C24.6558 22.8524 24.7389 22.6929 24.8714 22.5918C24.968 22.5177 25.0871 22.4706 25.2173 22.4706H25.3116H25.5901C25.9001 22.4706 26.1516 22.7221 26.1516 23.032V23.4049Z",
    fill: "#5AC8FA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(11.625 11)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMoneyWithdraw);
export default __webpack_public_path__ + "static/media/ic_money_withdraw.68845662d54794e527b3f72c66c9a9ba.svg";
export { ForwardRef as ReactComponent };